const TwitterLogo = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_497_13261)">
        <rect width="40" height="40" fill="#EEFBFF" />
        <path
          d="M29.9274 13.6217C29.2669 13.9059 28.5726 14.1039 27.8615 14.2106C28.1939 14.1536 28.6831 13.5552 28.8778 13.313C29.1736 12.9477 29.3991 12.5306 29.5427 12.083C29.5427 12.0497 29.5759 12.0022 29.5427 11.9785C29.5259 11.9694 29.5072 11.9646 29.4881 11.9646C29.469 11.9646 29.4502 11.9694 29.4335 11.9785C28.6613 12.3966 27.8396 12.7157 26.9877 12.9283C26.958 12.9374 26.9264 12.9382 26.8962 12.9307C26.8661 12.9232 26.8386 12.9076 26.8167 12.8856C26.7504 12.8066 26.679 12.7321 26.603 12.6624C26.2555 12.351 25.8613 12.0962 25.4347 11.9073C24.8589 11.671 24.2369 11.5687 23.6158 11.6081C23.0131 11.6461 22.4247 11.8078 21.8871 12.083C21.3578 12.3731 20.8925 12.7673 20.5194 13.2418C20.1268 13.7301 19.8435 14.2969 19.6883 14.904C19.5603 15.4814 19.5458 16.0782 19.6455 16.6611C19.6455 16.7609 19.6455 16.7751 19.56 16.7609C16.1739 16.2622 13.3957 15.0607 11.1256 12.4819C11.0259 12.3679 10.9736 12.3679 10.8929 12.4819C9.90509 13.9826 10.3847 16.3572 11.6195 17.5302C11.7857 17.6869 11.9567 17.8389 12.1372 17.9814C11.571 17.9412 11.0187 17.7878 10.513 17.5302C10.418 17.4685 10.3658 17.5017 10.361 17.6157C10.3475 17.7737 10.3475 17.9326 10.361 18.0906C10.4601 18.8479 10.7585 19.5653 11.2258 20.1694C11.6931 20.7735 12.3124 21.2427 13.0205 21.529C13.1931 21.6029 13.373 21.6586 13.5572 21.6952C13.0331 21.7984 12.4955 21.8144 11.9662 21.7427C11.8522 21.7189 11.8095 21.7807 11.8522 21.8899C12.5503 23.7896 14.0653 24.369 15.1766 24.6919C15.3286 24.7156 15.4806 24.7156 15.6515 24.7536C15.6515 24.7536 15.6515 24.7536 15.623 24.7821C15.2953 25.3805 13.9703 25.7842 13.3624 25.9932C12.2529 26.3917 11.0699 26.544 9.89559 26.4396C9.71037 26.4111 9.66763 26.4158 9.62014 26.4396C9.57265 26.4633 9.62014 26.5156 9.67238 26.563C9.90984 26.7198 10.1473 26.8575 10.3942 26.9905C11.1294 27.3915 11.9067 27.71 12.7118 27.9403C16.8815 29.0896 21.5737 28.2442 24.7033 25.1336C27.1634 22.6925 28.0277 19.3254 28.0277 15.9535C28.0277 15.8253 28.1844 15.7493 28.2747 15.6828C28.8971 15.1979 29.4458 14.6252 29.9036 13.9826C29.9829 13.8868 30.0236 13.7649 30.0176 13.6407C30.0176 13.5695 30.0176 13.5837 29.9274 13.6217Z"
          fill="#33CCFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_497_13261">
          <rect width="40" height="40" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const FacebookLogo = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_497_13348)">
        <rect width="40" height="40" rx="20" fill="#337FFF" />
        <path
          d="M24.8941 21.302L25.464 17.6809H21.9533V15.3272C21.9533 14.3371 22.4434 13.3696 24.0107 13.3696H25.6293V10.286C24.6867 10.1357 23.7343 10.0544 22.7797 10.0427C19.8902 10.0427 18.0037 11.7797 18.0037 14.9199V17.6809H14.8008V21.302H18.0037V30.0605H21.9533V21.302H24.8941Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_497_13348">
          <rect width="40" height="40" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const SearchIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9265 17.0401L20.3996 20.4001M19.2796 11.4401C19.2796 15.77 15.7695 19.2801 11.4396 19.2801C7.1097 19.2801 3.59961 15.77 3.59961 11.4401C3.59961 7.11019 7.1097 3.6001 11.4396 3.6001C15.7695 3.6001 19.2796 7.11019 19.2796 11.4401Z"
        stroke="#3F3A52"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

const ArrowRotate = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.11909 10.0001C2.95893 12.5552 5.36421 14.4001 8.20039 14.4001C11.735 14.4001 14.6004 11.5347 14.6004 8.0001C14.6004 4.46547 11.735 1.6001 8.20039 1.6001C5.83149 1.6001 3.76319 2.88713 2.6566 4.8001M4.60039 5.6001H1.40039V2.4001"
        stroke="#01A7FA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { TwitterLogo, SearchIcon, ArrowRotate, FacebookLogo };
